<template>
  <div>
    <v-row>
      <v-col sm="12" md="4" lg="4" xl="4">
        <v-card dark>
          <v-card-title class="d-flex justify-center">
            <p class="text-h6">Importar Vendas</p>
          </v-card-title>
          <v-container>
            <v-file-input
              label="Localizar arquivo .xls"
              dense
              outlined
              @change="changeFile($event)"
            ></v-file-input>
            <div class="d-flex flex-column justify-center white--text text-h6">
              <p>Estatísticas <v-icon>mdi-chart-bar</v-icon></p>
              <p class="font-weight-medium">
                Orçamentos:
                <span class="orange--text">{{ orderSpecs.warnings }}</span
                >(revisar)
                <span class="green--text">{{ orderSpecs.valid }} </span
                >(válidos)
                <span class="white--text">{{ orderSpecs.orders }}</span
                >(total)
              </p>
              <span>Itens: {{ orderSpecs.items }}</span>
            </div>
          </v-container>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" lg="8" xl="8">
        <v-card dark>
          <v-card-title class="d-flex justify-center">
            <p class="text-h6">Configurações</p>
          </v-card-title>
          <v-card-text>
            <v-form ref="formulario" v-model="formValid">
              <div class="d-flex flex-column justify-center">
                <v-row dense>
                  <v-col xs="12" sm="6" md="4" class="d-sm-inline-block">
                    <c-select
                      item-text="DESCRICAO"
                      item-value="CODIGO"
                      :lista="systemList"
                      :item.sync="form.filial"
                      :rotulo="$t('labels.filial')"
                      v-model="form.FILIAL"
                      :isRequired="true"
                    />
                  </v-col>
                  <v-col xs="12" sm="6" md="4" class="d-sm-inline-block">
                    <c-select
                      item-text="NOME"
                      item-value="CODIGO"
                      :lista="usersList"
                      :item.sync="form.vendedorpedido"
                      :rotulo="'Vendedor Pedido'"
                      v-model="form.VENDEDORPEDIDO"
                      :isRequired="true"
                    />
                  </v-col>
                  <v-col xs="12" sm="6" md="4" class="d-sm-inline-block">
                    <c-select
                      item-text="NOME"
                      item-value="CODIGO"
                      :lista="usersList"
                      :item.sync="form.vendedorbrinde"
                      :rotulo="'Vendedor Brinde'"
                      v-model="form.VENDEDORBRINDE"
                      :isRequired="true"
                    />
                  </v-col>
                  <v-col xs="12" md="4" sm="6" class="d-sm-inline-block">
                    <c-input
                      :label="$t('labels.cupombrinde')"
                      :placeholder="$t('labels.cupombrinde')"
                      :maxLength="12"
                      v-model="form.CUPOMBRINDE"
                    />
                  </v-col>
                  <v-col md="4" xs="5" sm="6" class="d-sm-inline-block">
                    <c-select-multiple
                      item-text="DESCRICAO"
                      item-value="DESCRICAO"
                      :lista="statusList"
                      :item.sync="form.status"
                      :size="statusList.length"
                      :rotulo="'Ignorar status'"
                      v-model="form.STATUS"
                    />
                  </v-col>
                  <v-col md="4" xs="3" sm="6" class="d-sm-inline-block">
                    <c-select
                      item-text="DESCRICAO"
                      item-value="CODIGO"
                      :lista="itemList"
                      :item.sync="form.itemfrete"
                      :rotulo="'Item Frete'"
                      v-model="form.ITEMFRETE"
                      @searchinput="updateItemFrete($event)"
                      :isRequired="true"
                    />
                  </v-col>
                  <v-checkbox
                    label="Importar cancelados"
                    color="green"
                    v-model="form.cancelados"
                    hide-details
                  />
                </v-row>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn
              class="rounded-lg"
              color="info"
              @click="send"
              :disabled="!hasOrders"
            >
              <span class="text-overline">Integrar</span>
              <v-icon right>mdi-refresh</v-icon>
            </v-btn>
            <v-btn
              class="rounded-lg"
              color="warning"
              @click="$emit('validate')"
              :disabled="!hasOrders"
            >
              <span class="text-overline">Validar</span>
              <v-icon right>mdi-reload</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { generateXlsxFile } from '@/utils/integrationUtils'
import { mapActions, mapGetters } from 'vuex'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelectMultiple from '@/components/shared/base-input/BaseSelectMultiple.vue'

export default {
  name: 'ImportFile',
  computed: {
    // ...mapGetters({ products: 'itemModule/getItemList' }),
    ...mapGetters({
      systemList: 'systemModule/getComboBoxListSystems',
      currentSystem: 'systemModule/getCurrentSystem',
      usersList: 'userModule/getUsersList',
      authUser: 'authModule/getAuthUser',
      itemList: 'itemModule/getComboBoxList',
    }),
  },
  components: {
    cSelect,
    cInput,
    cSelectMultiple,
  },
  data() {
    return {
      formValid: false,
      integrationType: 'Produtos',
      integrationTypeList: ['Produtos'],
      timer: null,
      dataList: [],
      form: {
        FILIAL: '',
        VENDEDORPEDIDO: '',
        VENDEDORBRINDE: '',
        STATUS: '',
        CUPOMBRINDE: 'SEGUIDOR',
        ITEMFRETE: null,
        vendedorpedido: '',
        vendedorbrinde: '',
        itemfrete: null,
        filial: '',
        status: '',
        cancelados: false,
      },
    }
  },
  created: async function() {
    if (this.systemList.length == 0) await this.getFiliais()

    if (this.usersList.length == 0) await this.getUsersAPI({ todos: 'S' })

    let payload = null

    if (this.integration.ITEM_TAXAENTREGA?.length > 0) {
      const item =
        this.itemList.length > 0
          ? this.itemList.filter(
              (e) => e.CODIGO == this.integration.ITEM_TAXAENTREGA
            )
          : null

      if (!item)
        payload = {
          page: 1,
          produtoservico: 'Serviço',
          hibrido: this.integration.ITEM_TAXAENTREGA,
          pdvBalcao: false,
          perPage: 15,
        }
    } else
      payload = {
        page: 1,
        produtoservico: 'Serviço',
        pdvBalcao: false,
        perPage: 15,
      }

    if (payload) await this.getItemsAPI({ query: payload })

    this.form.filial = this.systemList.filter(
      (e) => e.CODIGO == this.integration.FILIAL
    )[0]
    this.form.vendedorpedido = await this.usersList.filter(
      (e) => e.CODIGO == this.authUser.CODIGO
    )[0]
    this.form.vendedorbrinde = this.usersList.filter(
      (e) => e.CODIGO == this.authUser.CODIGO
    )[0]
    this.form.itemfrete = this.itemList.filter(
      (e) => e.CODIGO == this.integration.ITEM_TAXAENTREGA
    )[0]
  },
  methods: {
    ...mapActions({
      getItens: 'itemModule/getItens',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
      getItemsAPI: 'itemModule/getItens',
    }),
    ...mapActions('userModule', ['getUsersAPI']),
    ...mapActions('systemModule', ['getSystems']),
    async send() {
      if (!this.$refs.formulario.validate()) {
        this.$toasted.error(this.$t('validation-messages.corrigir'))
        return
      }
      this.$emit('prepareToSend', this.form)
    },
    async changeFile($event) {
      await this.updateStatus()
      this.$emit('changeFile', $event)
    },
    async updateStatus() {
      //
    },
    async updateItemFrete($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          let payload = {
            page: 1,
            produtoservico: 'Serviço',
            pdvBalcao: false,
            perPage: 15,
            hibrido: param,
          }

          this.getItemsAPI({ query: payload })
        }, 600)
      } catch (error) {
        this.$toasted.error(`Erro ao buscar Item Frete ${error}`)
      }
    },
    async getFiliais() {
      try {
        await this.getSystems({ page: 1 })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    async generateFile() {
      try {
        this.setLoadingDialogMessage(
          'O download da planilha será realizado em seguida.'
        )
        this.showLoadingDialog(true)
        let data = new Date()
        const filename = `${this.integrationType}-${data.getTime()}`

        switch (this.integrationType) {
          case this.integrationTypeList[0]: {
            await this.getItens({ query: { pdvBalcao: false } })
            this.dataList = this.products
            break
          }
          case this.integrationTypeList[1]: {
            break
          }
          default:
            break
        }
        generateXlsxFile(this.dataList, filename)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
  },
  props: {
    integration: {
      type: Object,
      required: true,
    },
    hasOrders: {
      type: Boolean,
      default: false,
    },
    orderSpecs: {
      type: Object,
      default: () => undefined,
    },
    statusList: {
      type: Array,
      default: () => [
        { DESCRICAO: 'AGUARDANDO PAGAMENTO' },
        { DESCRICAO: 'A ENVIAR YAPAY' },
        { DESCRICAO: 'AGUARDANDO YAPAY' },
        { DESCRICAO: 'ENVIADO' },
        { DESCRICAO: 'CANCELADO AUT' },
        { DESCRICAO: 'FINALIZADO' },
        { DESCRICAO: 'CANCELADO' },
      ],
    },
  },
}
</script>

<style></style>
